import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11cc5b88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabular-field-control" }
const _hoisted_2 = { class: "head-row" }
const _hoisted_3 = { class: "head-cell move-column" }
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "head-cell" }, "[Table-Header]", -1))
const _hoisted_6 = { class: "head-cell duplicate-column" }
const _hoisted_7 = { class: "icon" }
const _hoisted_8 = { class: "head-cell delete-column" }
const _hoisted_9 = { class: "icon" }
const _hoisted_10 = { ref: "table" }
const _hoisted_11 = ["onPointerdown"]
const _hoisted_12 = { class: "icon" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "data-column" }, "[Table-Row]", -1))
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "icon" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "✗", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "actions" }
const _hoisted_20 = { class: "builtin" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_22 = { class: "registered" }
const _hoisted_23 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MoveArrow = _resolveComponent("MoveArrow")!
  const _component_Duplicate = _resolveComponent("Duplicate")!
  const _component_Trash = _resolveComponent("Trash")!
  const _component_MoveDots = _resolveComponent("MoveDots")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", null, [
      _createElementVNode("thead", _hoisted_2, [
        _createElementVNode("th", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_component_MoveArrow)
          ])
        ]),
        _renderSlot(_ctx.$slots, "table-header", { columns: _ctx.columns }, () => [
          _hoisted_5
        ], true),
        _createElementVNode("th", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, [
            _createVNode(_component_Duplicate)
          ])
        ]),
        _createElementVNode("th", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, [
            _createVNode(_component_Trash)
          ])
        ])
      ]),
      _createElementVNode("tbody", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.property.value, ([key, row]) => {
          return (_openBlock(), _createElementBlock("tr", {
            class: "body-row",
            key: key
          }, [
            _createElementVNode("td", {
              class: "move-column",
              onPointerdown: ($event: any) => (_ctx.onStartDrag(key, $event))
            }, [
              _createElementVNode("span", _hoisted_12, [
                _createVNode(_component_MoveDots)
              ])
            ], 40, _hoisted_11),
            _renderSlot(_ctx.$slots, "table-row", {
              key: key,
              row: row
            }, () => [
              _hoisted_13
            ], true),
            _createElementVNode("td", {
              class: "duplicate-column",
              onClick: ($event: any) => (_ctx.onDuplicate(key))
            }, [
              _createElementVNode("span", _hoisted_15, [
                _createVNode(_component_Duplicate)
              ])
            ], 8, _hoisted_14),
            _createElementVNode("td", {
              class: "delete-column",
              onClick: ($event: any) => (_ctx.onDelete(key))
            }, _hoisted_18, 8, _hoisted_16)
          ]))
        }), 128))
      ], 512)
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCreate && _ctx.onCreate(...args)))
        }, "+ Add")
      ]),
      (_ctx.property.actions !== null && 0 !== _ctx.property.actions.size)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.property.actions, ([k, a]) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: k,
                  onClick: ($event: any) => (_ctx.onAction(k))
                }, _toDisplayString(a.text), 9, _hoisted_23))
              }), 128))
            ])
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}